import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Getting Started";
const frontMatter = {};
import {Tabs as $Tabs} from "nextra/components";
import {TerminalIcon} from "nextra/icons";
import {TypeScriptIcon} from "nextra/icons";
export function useTOC(props) {
  return [{
    value: "Installation",
    id: "installation",
    depth: 2
  }, {
    value: "Observable Hooks",
    id: "observable-hooks",
    depth: 2
  }, {
    value: "useObservable()",
    id: "useobservable",
    depth: 3
  }, {
    value: "useObservableEvent()",
    id: "useobservableevent",
    depth: 3
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  if (!$Tabs) _missingMdxReference("$Tabs", false);
  if (!$Tabs.Tab) _missingMdxReference("$Tabs.Tab", true);
  return <><_components.h1>{"Getting Started"}</_components.h1>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<$Tabs items={["npm", "pnpm", "yarn", "bun"]} storageKey="selectedPackageManager"><$Tabs.Tab><_components.pre icon={TerminalIcon} tabIndex="0" data-language="sh" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"npm"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" i"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" react-rx"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" rxjs"}</_components.span></_components.span></_components.code></_components.pre></$Tabs.Tab><$Tabs.Tab><_components.pre icon={TerminalIcon} tabIndex="0" data-language="sh" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"pnpm"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" add"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" react-rx"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" rxjs"}</_components.span></_components.span></_components.code></_components.pre></$Tabs.Tab><$Tabs.Tab><_components.pre icon={TerminalIcon} tabIndex="0" data-language="sh" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"yarn"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" add"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" react-rx"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" rxjs"}</_components.span></_components.span></_components.code></_components.pre></$Tabs.Tab><$Tabs.Tab><_components.pre icon={TerminalIcon} tabIndex="0" data-language="sh" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"bun"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" add"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" react-rx"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" rxjs"}</_components.span></_components.span></_components.code></_components.pre></$Tabs.Tab></$Tabs>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.p>{"Use observables in React components with the "}<_components.code>{"useObservable"}</_components.code>{" hook."}</_components.p>{"\n"}<_components.p>{"If you need to subscribe to an observable in your component, this hook will give you the current value from it"}</_components.p>{"\n"}<_components.p>{"Example:"}</_components.p>{"\n"}<_components.pre icon={TypeScriptIcon} tabIndex="0" data-language="tsx" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useMemo} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useObservable} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react-rx'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {interval} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'rxjs'"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" MyComponent"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"props"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" observable"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useMemo"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(() "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" interval"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"100"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"), [])"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" number"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(observable, "}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"0"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  return"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" <>The number is {number}</>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"The "}<_components.code>{"initialValue"}</_components.code>{" argument is optional. If its omitted, the value returned from "}<_components.code>{"useObservable"}</_components.code>{" may be "}<_components.code>{"null"}</_components.code>{" initially. If the observable emits a value "}<_components.em>{"synchronously"}</_components.em>{" at subscription time, that value will be used as the initial value, and any "}<_components.code>{"initialValue"}</_components.code>{" passed as argument to "}<_components.code>{"useObservable"}</_components.code>{" will be ignored:"}</_components.p>{"\n"}<_components.pre icon={TypeScriptIcon} tabIndex="0" data-language="tsx" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useMemo} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useObservable} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react-rx'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {of} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'rxjs'"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6A737D",
    "--shiki-dark": "#6A737D"
  }}>{"// This component will never render \"Hello mars!\" since the observable emits \"world\" synchronously."}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" MyComponent"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"props"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" observable"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useMemo"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"() "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" of"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{"'world'"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"),[])"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" planet"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(observable, "}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{"'mars'"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  return"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" <>Hello {planet}!</>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"The "}<_components.code>{"disabled"}</_components.code>{" option is optional. If its omitted, the hook will subscribe to the observable and return the current value. If its "}<_components.code>{"true"}</_components.code>{" initially, the hook will not subscribe to the observable and return the "}<_components.code>{"initialValue"}</_components.code>{" if provided. In the event that it has already subscribed it will then unsubscribe from the observable and return the last value it received."}</_components.p>{"\n"}<_components.pre icon={TypeScriptIcon} tabIndex="0" data-language="tsx" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useMemo} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useObservable} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react-rx'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {of} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'rxjs'"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6A737D",
    "--shiki-dark": "#6A737D"
  }}>{"// This component will never render \"Hello world!\" since the observable emits \"world\" asynchronously and the disabled option is true."}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" MyComponent"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"props"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" observable"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useMemo"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"() "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" of"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(),[])"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" planet"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(observable, "}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{"'mars'"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{", {disabled: "}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"true"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"})"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"  useEffect"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(() "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"    observable."}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"next"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{"'world'"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"  },[observable])"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  return"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" <>Hello {planet}!</>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h3 id={toc[3].id}>{toc[3].value}</_components.h3>{"\n"}<_components.p>{"This creates an event handler that can be used to create an observable from events."}</_components.p>{"\n"}<_components.p>{"Here’s an example of a component that displays the current value from a range input:"}</_components.p>{"\n"}<_components.pre icon={TypeScriptIcon} tabIndex="0" data-language="tsx" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useState} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {useObservableEvent} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'react-rx'"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"import"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {filter, map, tap} "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"from"}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{" 'rxjs/operators'"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"const"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" ShowSliderValue"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" () "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" ["}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"value"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{", "}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"setValue"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"] "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useState"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"0"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  const"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" handleChange"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" ="}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservableEvent"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"value$"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"    value$."}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"pipe"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"("}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6A737D",
    "--shiki-dark": "#6A737D"
  }}>{"      // Ignore null values"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"      filter"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(nonNullable),"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6A737D",
    "--shiki-dark": "#6A737D"
  }}>{"      // Cast to number"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"      map"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"value"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" Number"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(value)),"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6A737D",
    "--shiki-dark": "#6A737D"
  }}>{"      // Update local state"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"      tap"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(setValue),"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"    ),"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"  )"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  return"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"    <>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"      <"}</_components.span><_components.span style={{
    "--shiki-light": "#22863A",
    "--shiki-dark": "#85E89D"
  }}>{"input"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"        type"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#032F62",
    "--shiki-dark": "#9ECBFF"
  }}>{"\"range\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"        value"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"{value}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"        onChange"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"{("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"event"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{") "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"=>"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" handleChange"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"(event.target.value)}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"        min"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"{"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"1"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"        max"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"{"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{"10"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"      />"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"      <"}</_components.span><_components.span style={{
    "--shiki-light": "#22863A",
    "--shiki-dark": "#85E89D"
  }}>{"div"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">Value is: {value}</"}</_components.span><_components.span style={{
    "--shiki-light": "#22863A",
    "--shiki-dark": "#85E89D"
  }}>{"div"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"    </>"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"  )"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" nonNullable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"v"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{" v"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" is"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" NonNullable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"> {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"  return"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" v "}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"!=="}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" null"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></>;
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/guide',
  {"filePath":"src/pages/guide.md","timestamp":1758550271000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)